import React, { useMemo } from 'react';
import { IPreReversalReport } from '@nkr/models/index';
import { ColDef, FirstDataRenderedEvent, GridApi, GridReadyEvent, GridSizeChangedEvent, ICellRendererParams, IHeaderParams, ModelUpdatedEvent, RowDataChangedEvent, SortChangedEvent, ValueGetterParams } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { DropdownButton, FormControl, MenuItem, OverlayTrigger, Popover } from 'react-bootstrap';
import SortableHeaderComponent from '@nkr/views/admin/center/list/common/sortable-header';
import { GridWrapper } from './styles';
import ReactHtmlParser from 'react-html-parser';
import moment from 'moment';

interface IProps {
    data: IPreReversalReport[],
    isCenterLogin?: boolean,
    onBillableCenterChange: (data: IPreReversalReport, centerId: number) => void,
    onGridReady: (e: GridReadyEvent) => void
}



const Grid = (props: IProps) => {
    const onGridReady = (e: GridReadyEvent) => {
        props.onGridReady(e);

        e.api.sizeColumnsToFit();
    }
    const onModelUpdated = (e: ModelUpdatedEvent) => fit(e.api);

    const onGridSizeChanged = (e: GridSizeChangedEvent) => {
    };

    const onFirstDataRendered = (e: FirstDataRenderedEvent) => {
        e.api.sizeColumnsToFit();
    };

    const fit = (api: GridApi) => {
        const el = document.getElementById('grid-wrapper');
        if (el && el.clientWidth > 0) api.sizeColumnsToFit();
    };

    const onSortChanged = (e: SortChangedEvent) => {
        e.api.refreshCells();
    };

    const handleCenterSelect = (data: IPreReversalReport, centerId: number) => props.onBillableCenterChange(data, centerId);

    const getOverlay = (id: number) => {
        let reportRecord = props.data.find(x => x.id == id);

        if (reportRecord != null)
            return (
                <Popover>
                    {ReactHtmlParser(reportRecord.rejectedReasonDetail)}
                </Popover>
            );

        return <Popover></Popover>;
    };

    const reportColumns: ColDef[] = [
        {
            colId: 'Rank',
            field: 'rank',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Row #
                </SortableHeaderComponent>,
            headerName: 'Row #',
            width: 45,
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            resizable: true,
            suppressSizeToFit: true,
            valueGetter: (props: ValueGetterParams) => props.node.rowIndex + 1
        },
        {
            colId: 'id',
            field: 'id',
            headerName: 'ID',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    ID
                </SortableHeaderComponent>,
            width: 80,
            sortable: true,
            resizable: true
        },


        {
            colId: 'donorCenter',
            field: 'donorCenter',
            headerName: 'Donor Center',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Donor Center
                </SortableHeaderComponent>,
            cellRendererFramework: (props: ICellRendererParams) => {
                return <><span>{props.data.donorCenter}</span>  {props.data.rdnCenterAlias != "" ? <span style={{ color: '#d9534f', fontWeight: 'bold' }}> ({props.data.rdnCenterAlias})</span> : ""}</>;
            },
            width: 120,
            sortable: true,
            resizable: true
        },
        {
            colId: 'donorAlias',
            field: 'donorAlias',
            headerName: 'Donor Alias',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Donor Alias
                </SortableHeaderComponent>,
            width: 120,
            sortable: true,
            resizable: true
        },

        {
            colId: 'recipientCenter',
            field: 'recipientCenter',
            headerName: 'Recipient Center',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Recipient Center
                </SortableHeaderComponent>,
            width: 120,
            sortable: true,
            resizable: true
        },
        {
            colId: 'recipientAlias',
            field: 'recipientAlias',
            headerName: 'Recipient Alias',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Recipient Alias
                </SortableHeaderComponent>,
            width: 120,
            sortable: true,
            resizable: true
        },
        {
            colId: 'accepted',
            field: 'accepted',
            headerName: 'Accepted',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Accepted
                </SortableHeaderComponent>,
            width: 100,
            sortable: true,
            resizable: true
        },
        {
            colId: 'reversed',
            field: 'reversed',
            headerName: 'Reversed',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            width: 100,
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Reversed
                </SortableHeaderComponent>,
            sortable: true,
            resizable: true
        },
        {
            colId: 'swap',
            field: 'swap',
            headerName: 'Swap',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Swap
                </SortableHeaderComponent>,
            width: 70,
            sortable: true,
            resizable: true
        },
        {
            colId: 'cluster',
            field: 'cluster',
            headerName: 'Cluster',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Cluster
                </SortableHeaderComponent>,
            width: 70,
            sortable: true,
            resizable: true
        },
        {
            colId: 'position',
            field: 'position',
            headerName: 'Position',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Position
                </SortableHeaderComponent>,
            width: 70,
            sortable: true,
            resizable: true
        },
        {
            colId: 'rejectedReasonDetail',
            field: 'rejectedReasonDetail',
            headerName: 'Decline Reason',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Decline Reason
                </SortableHeaderComponent>,
            cellRendererFramework: (props: ICellRendererParams) =>
                <div>
                    <OverlayTrigger trigger={['hover', 'focus']} placement='bottom' overlay={getOverlay(props.data.id)}>
                        <div>
                            {props.data.rejectedReasonDetail.length == 0 ? '' : props.data.rejectedReasonDetail.substring(0, 25) + '...'}
                        </div>
                    </OverlayTrigger>
                </div>,
            width: 170,
            sortable: true,
            resizable: true
        },
        {
            colId: 'byInitials',
            field: 'byInitials',
            headerName: 'By Initials',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    By Initials
                </SortableHeaderComponent>,
            width: 90,
            sortable: true,
            resizable: true
        },
        {
            colId: 'actions',
            field: '',
            headerName: 'actions',
            headerClass: 'center-list-header',
            suppressCellFlash: true,
            cellClass: 'center-list-cell no-range',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Billable Center</SortableHeaderComponent>,
            sortable: false,
            cellStyle: { overflow: 'visible' },
            width: 120,
            hide: props.isCenterLogin,
            cellRendererFramework: (props: ICellRendererParams) => {
                let data = props.data as IPreReversalReport;
                return <div style={{ width: '100%' }}>
                    <select
                        className='form-control input-sm'
                        style={{
                            width: 110,
                            minWidth: 110,
                            maxWidth: 110,
                            flex: '0 0 110px',
                            height: 24,
                            padding: '0 4px',
                            fontSize: 12,
                            backgroundColor: '#337ab7',
                            borderColor: '#2e6da4',
                            color: '#fff',
                            boxShadow: 'none'
                        }}
                        value={data.reversalResponsible || 0}
                        onChange={(e) => handleCenterSelect(data, parseInt(e.currentTarget.value))}
                    >
                        <option style={{ backgroundColor: '#fff', color: '#333' }} value={2}>{data.recipientCenter}</option>
                        <option style={{ backgroundColor: '#fff', color: '#333' }} value={1}>{data.rdnCenterAlias != "" ? data.rdnCenterAlias : data.donorCenter}</option>
                        <option style={{ backgroundColor: '#fff', color: '#333' }} value={0}>None</option>
                    </select>
                </div>
            }
        },
    ];

    const columnDefs = useMemo(() => reportColumns, [props.data]);
    const rowData = useMemo(() => props.data, [props.data]);

    return (
        <GridWrapper id='grid-wrapper' className='container-fluid-max-sm ag-theme-bootstrap'>
            <AgGridReact
                enableCellTextSelection={true}
                enableRangeSelection={true}
                columnDefs={columnDefs}
                rowData={rowData}
                rowHeight={30}
                noRowsOverlayComponentFramework={() => <div>No data for the selected date range...</div>}
                suppressCellSelection={true}
                onGridReady={onGridReady}
                onGridSizeChanged={onGridSizeChanged}
                onFirstDataRendered={onFirstDataRendered}
                onSortChanged={onSortChanged}
                onModelUpdated={onModelUpdated}
            />
        </GridWrapper>
    );
}

export default Grid;